import React from "react";
import "./SectionFour.css";
import { Col, Container, Row } from "react-bootstrap";
const SectionFour = () => {
  return (
    <>
      <section className="we-fly">
        <div className="we-fly-bg-box">
          <div
            className="we-fly__bg"
            style={{
              backgroundImage: "url('/Images/indigo-flight.png')",
            }}
          />
        </div>
        <div className="container">
          <img
            src="https://jetly-html.vercel.app/main-html/assets/images/shapes/we-fly-badge.png"
            alt=""
            className="we-fly__badge"
          />
          <div className="row">
            <div className="col-xl-7 col-lg-8">
              <div className="we-fly__left">
                <h3 className="we-fly__title count-box counted">
                  Exclusive Benefits for
                  <span
                    className="count-text we-fly__count"
                    data-stop={6800}
                    data-speed={1500}
                  >
                    Yatri Service
                  </span>{" "}
                  Agents
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="section_one_section_mainDiv">
        <Container>
          <Row
            className="d-flex justify-content-between"
            // style={{ paddingTop: "25px" }}
          >
            <Col xs={12} md={4} sm={12}>
              <div className="cardKeyHiglht" style={{ textAlign: "center" }}>
                <img
                  src="/Images/pic1.png"
                  style={{
                    width: "60px",
                    height: "60px",
                    textAlign: "center",
                    margin: "auto",
                  }}
                  // src="https://admin.flyabasin.com/public/images/flights.png"
                  alt="Flights"
                />
                <h4
                  className="section_four_home_inner"
                  style={{ textAlign: "center" }}
                >
                  Personalized Support
                </h4>
                <p>
                  Our dedicated account managers are here to assist you
                  personally. Get tailored advice, industry insights, and
                  support to help you succeed.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} sm={12}>
              <div className="cardKeyHiglht" style={{ textAlign: "center" }}>
                <img
                  src="/Images/pic2.png"
                  style={{ width: "60px", height: "60px", textAlign: "center" }} // src="https://admin.flyabasin.com/public/images/hotels.png"
                  alt="Hotel"
                />
                <h4
                  className="section_four_home_inner"
                  style={{ textAlign: "center" }}
                >
                  Partner with Airlines
                </h4>
                <p>
                  Benefit from our partnerships with renowned airlines. Access
                  special deals, discounts, and unique offerings for your
                  clients.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} sm={12}>
              <div className="cardKeyHiglht" style={{ textAlign: "center" }}>
                <img
                src="/Images/live-chat.png"
                  // src="https://cdn-icons-png.freepik.com/512/4230/4230715.png?uid=R155952951&ga=GA1.1.12114912.1717589849"
                  style={{ width: "60px", height: "60px", textAlign: "center" }}
                  // src="https://admin.flyabasin.com/public/images/holidays.png"
                  alt="Holiday"
                />
                <h4
                  className="section_four_home_inner"
                  style={{ textAlign: "center" }}
                >
                  Improved Security Standards
                </h4>
                <p>
                  Yatri Service ensures data and transaction security, complying
                  with industry standards to provide a safe environment for your
                  business.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SectionFour;
